export default __webpack_public_path__ + "static/media/info_timeline.8dcda94b.png";